export class CollisionCollider {
  constructor(scene, opts) {
    this._sensor = opts.sensor || false;
    this._destroyed = false;
    this._enabled = opts.hasOwnProperty('enabled') ? opts.enabled : true;
    this._gameObject = opts.gameObject;
    this._rect = new Phaser.Geom.Rectangle(
      opts.x || 0,
      opts.y || 0,
      opts.width || 0,
      opts.height || 0
    );
    this._collisionColliders = [];
    this._debugColour = opts.debugColour || 0xff0000;
    this._collidesWithGroups = [];
    this._collisionGroup = opts.hasOwnProperty('collisionGroup') ? opts.collisionGroup : -1;
    this._depth = opts.depth || false;
    this.dirty = this.solid;

    if (opts.collidesWith) this.setCollidesWith(opts.collidesWith);
    if (scene.collisionMap) {
      scene.collisionMap._registerCollisionCollider(this);
    } else {
      console.warn(
        'scene.collisionMap not found ensure to create a collision map before adding colliders'
      );
    }
  }
  get depth() {
    return this._depth || this.gameObject?.y || this.rect.y + this.rect.height;
  }
  set depth(value) {
    this._depth = value;
  }
  get debugColour() {
    return this._debugColour;
  }
  set enabled(value) {
    this._enabled = value;
    if (!this._enabled) this._collisionColliders = [];
    this.dirty = this.solid;
  }
  get enabled() {
    return this._enabled && !this._destroyed && this.rect.width > 0 && this.rect.height > 0;
  }
  get rect() {
    return this._rect;
  }
  // set sensor(value) {
  //   this._sensor = value;
  // }
  get sensor() {
    return this._sensor;
  }
  get solid() {
    return !this._sensor;
  }
  // set solid(value) {
  //   this._sensor = value;
  // }
  get gameObject() {
    return this._gameObject;
  }
  get destroyed() {
    return this._destroyed;
  }
  // =============================================================================================
  // positioning
  // =============================================================================================
  set x(value) {
    this.rect.x = value;
    this.dirty = this.solid;
  }
  get x() {
    return this.rect.x;
  }
  set y(value) {
    this.rect.y = value;
    this.dirty = this.solid;
  }
  get y() {
    return this.rect.y;
  }

  // =============================================================================================
  // size
  // =============================================================================================
  set width(value) {
    this.rect.width = value;
    this.dirty = this.solid;
  }
  get width() {
    return this.rect.width;
  }
  set height(value) {
    this.rect.height = value;
    this.dirty = this.solid;
  }
  get height() {
    return this.rect.height;
  }

  setSize(width, height) {
    this.width = width;
    this.height = height;
  }

  // =============================================================================================
  // quick reference
  // =============================================================================================
  get top() {
    return this.rect.top;
  }
  get bottom() {
    return this.rect.bottom;
  }
  get right() {
    return this.rect.right;
  }
  get left() {
    return this.rect.left;
  }
  get centerX() {
    return this._rect.centerX;
  }
  get centerY() {
    return this._rect.centerY;
  }
  get center() {
    return { x: this.centerX, y: this.centerY };
  }
  // =============================================================================================
  // COLLISION GROUPS
  // =============================================================================================
  set collisionGroup(value) {
    this._collisionGroup = value;
  }
  get collisionGroup() {
    return this._collisionGroup;
  }
  setCollidesWith(collisionGroups) {
    if (Array.isArray(collisionGroups)) {
      this._collidesWithGroups = [...collisionGroups];
    } else this._collidesWithGroups = [collisionGroups];
  }
  canCollideWith(collider) {
    if (!this._collidesWithGroups?.length) return collider != this;
    return (
      collider != this &&
      (this.collisionGroup === -1 || this._collidesWithGroups.indexOf(collider.collisionGroup) > -1)
    );
  }

  getCollisionCount() {
    return this._collisionColliders.length;
  }

  getCollisions(filter) {
    if (!this.enabled) return [];
    if (filter) {
      if (Array.isArray(filter)) {
        return this._collisionColliders.filter(
          (c) => c.enabled && filter.indexOf(c.collisionGroup) > -1
        );
      } else
        return this._collisionColliders.filter((c) => c.enabled && c.collisionGroup === filter);
    }
    return this._collisionColliders.filter((c) => c.enabled);
  }

  // =============================================================================================
  // overlaps
  // =============================================================================================
  overlapsArea(x, y, width, height) {
    return (
      x + width > this.rect.x &&
      x < this.rect.right &&
      y + height > this.rect.y &&
      y < this.rect.bottom
    );
  }
  overlapsRect(rect) {
    return Phaser.Geom.Rectangle.Overlaps(this._rect, rect);
  }
  overlapsCollider(collider) {
    if (collider === this || !this.canCollideWith(collider)) return false;
    return Phaser.Geom.Rectangle.Overlaps(this._rect, collider.rect);
  }

  contains(x, y) {
    return this.rect.contains(x, y);
  }
  // =============================================================================================
  // collision colliders
  // =============================================================================================
  clearCollisionColliders() {
    this._collisionColliders = [];
  }
  addCollisionCollider(collider) {
    if (!this._collisionColliders.includes(collider)) this._collisionColliders.push(collider);
  }
  removeCollisionCollider(collider) {
    const index = this._collisionColliders.indexOf(collider);
    if (index > -1) this._collisionColliders.splice(index, 1);
  }
  checkCurrentCollisionColliders() {
    for (let collider, i = this._collisionColliders.length - 1; i >= 0; i--) {
      collider = this._collisionColliders[i];
      if (!collider.enabled) this._collisionColliders.splice(i, 1);
    }
  }

  // =============================================================================================
  // mark for destruction
  // =============================================================================================
  destroy() {
    this._collisionColliders = [];
    this._destroyed = true;
  }
  nullify() {
    this._sensor = null;
    this._destroyed = null;
    this._enabled = null;
    this._gameObject = null;
    this._rect = null;
    this._collisionColliders = null;
    this._debugColour = null;
  }
}
